import { render, staticRenderFns } from "./ProfileFormEmbedded.vue?vue&type=template&id=20c7fc0a"
import script from "./ProfileFormEmbedded.vue?vue&type=script&lang=ts"
export * from "./ProfileFormEmbedded.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports